import { NavLink, useLocation, useNavigate } from "react-router-dom";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import MiscellaneousServicesIcon from "@mui/icons-material/MiscellaneousServices";
import HubIcon from "@mui/icons-material/Hub";
import HandymanIcon from "@mui/icons-material/Handyman";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import BadgeIcon from "@mui/icons-material/Badge";
import KeyIcon from "@mui/icons-material/VpnKey";
import LogoutIcon from "@mui/icons-material/Logout";
import CategoryIcon from "@mui/icons-material/Category";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import InventoryIcon from "@mui/icons-material/Inventory";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import PlaceIcon from "@mui/icons-material/Place";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import CampaignIcon from "@mui/icons-material/Campaign";
import HomeWorkIcon from "@mui/icons-material/HomeWork";
import ShareIcon from "@mui/icons-material/Share";
import LinkIcon from "@mui/icons-material/Link";
import CardMembershipIcon from "@mui/icons-material/CardMembership";
import LiveTvIcon from "@mui/icons-material/LiveTv";
import ArticleIcon from "@mui/icons-material/Article";
import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import BusinessIcon from "@mui/icons-material/Business";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import TempleHinduIcon from "@mui/icons-material/TempleHindu";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import TouchAppIcon from "@mui/icons-material/TouchApp";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import {
  logoutAdmin,
  isAdminRole,
  isProviderRole,
  isSupplierRole,
  isVerifierRole,
  PROVIDER_ALLOWED_PAGES,
  SUPPLIER_ALLOWED_PAGES,
  buildAppPath,
} from "../../utils/auth";
import Logo from "../../assets/images/admin-logo.png";

const menuItems = [
  { label: "Dashboard", page: "dashboard", icon: DashboardIcon },
  { label: "Order Master", page: "order-master", icon: ReceiptLongIcon },
  { label: "Order Status Master", page: "order-status", icon: CategoryIcon },
  { label: "Shipment Tracking", page: "shipment-tracking", icon: LocalShippingIcon },
  { label: "Call to Action Master", page: "call-to-action", icon: TouchAppIcon },
  { label: "Category Master", page: "service-category", icon: MiscellaneousServicesIcon },
  { label: "Sub category Master", page: "service-sub-category", icon: HubIcon },
  { label: "Asset Type Master", page: "asset-type", icon: CategoryIcon },
  { label: "Asset Source Location", page: "asset-source-location", icon: LocationOnIcon },
  { label: "Asset Master", page: "services-master", icon: HandymanIcon },
  { label: "Asset Inventory", page: "asset-inventory", icon: InventoryIcon },
  { label: "Wishlist", page: "wishlist", icon: FavoriteBorderIcon },
  { label: "Cart", page: "cart", icon: ShoppingCartOutlinedIcon },
  { label: "Review & Rating", page: "review-rating", icon: StarBorderIcon },
  { label: "User Role", page: "user-role", icon: BadgeIcon },
  { label: "User Master", page: "user-master", icon: ManageAccountsIcon },
  { label: "Create Login", page: "create-login", icon: KeyIcon },
  { label: "Specialization", page: "specialization", icon: WorkspacePremiumIcon },
  { label: "Address Type Master", page: "address-type", icon: CategoryIcon },
  { label: "Address Master", page: "address-master", icon: HomeWorkIcon },
  { label: "Social Media Master", page: "social-media-master", icon: ShareIcon },
  { label: "User Social Media", page: "user-social-media", icon: LinkIcon },
  { label: "Awards & Certificates", page: "user-awards-certificates", icon: CardMembershipIcon },
  { label: "Media Type Master", page: "media-type", icon: LiveTvIcon },
  { label: "News & Media", page: "user-news-media", icon: ArticleIcon },
  { label: "KYC Master", page: "kyc-master", icon: BadgeOutlinedIcon },
  { label: "User KYC", page: "user-kyc", icon: FactCheckIcon },
  { label: "Establishment KYC", page: "establishment-kyc", icon: BusinessIcon },
  { label: "Bank Account Type", page: "bank-account-type", icon: AccountBalanceIcon },
  { label: "User Bank Account", page: "user-bank-account", icon: AccountBalanceWalletIcon },
  { label: "Dev Darshan", page: "dev-darshan", icon: TempleHinduIcon },
  { label: "Online Classes", page: "online-classes", icon: LiveTvIcon },
  { label: "Create Online Class", page: "create-online-class", icon: AddCircleOutlineIcon },
  { label: "Location Type Master", page: "location-type", icon: CategoryIcon },
  { label: "Location Master", page: "locations", icon: PlaceIcon },
  { label: "Advertisement Master", page: "advertisements", icon: CampaignIcon },
];

const verifierMenuItems = [
  { label: "User Details", page: "user-details", icon: FactCheckIcon },
  { label: "User Master", page: "user-master", icon: ManageAccountsIcon },
  { label: "Address Master", page: "address-master", icon: HomeWorkIcon },
  { label: "User Social Media", page: "user-social-media", icon: LinkIcon },
  { label: "Awards & Certificates", page: "user-awards-certificates", icon: CardMembershipIcon },
  { label: "News & Media", page: "user-news-media", icon: ArticleIcon },
];

function withRolePaths(items) {
  return items.map((item) => ({
    ...item,
    path: buildAppPath(item.page),
  }));
}

function pagesToMenuItems(pages) {
  return withRolePaths(
    pages.map((page) => menuItems.find((item) => item.page === page)).filter(Boolean)
  );
}

function getVisibleMenuItems() {
  if (isAdminRole()) return withRolePaths(menuItems);
  if (isVerifierRole()) return withRolePaths(verifierMenuItems);
  if (isSupplierRole()) return pagesToMenuItems(SUPPLIER_ALLOWED_PAGES);
  if (isProviderRole()) return pagesToMenuItems(PROVIDER_ALLOWED_PAGES);
  return [];
}

export default function AdminSidebar() {
  const location = useLocation();
  const navigate = useNavigate();
  const visibleItems = getVisibleMenuItems();

  const handleLogout = () => {
    logoutAdmin();
    navigate("/login");
  };

  return (
    <aside className="admin-sidebar">
      <div className="admin-sidebar__top">
        <div className="admin-sidebar__brand">
          <img src={Logo} alt="Trivom Tara" className="admin-sidebar__logo" />
        </div>

        <nav className="admin-sidebar__nav">
          {visibleItems.map((item) => {
            const Icon = item.icon;
            const onCreateClassPath =
              location.pathname.includes("/create-online-class") ||
              /\/online-classes\/create\/?$/.test(location.pathname);
            const isOnlineClassesActive =
              item.page === "online-classes" &&
              location.pathname.includes("/online-classes") &&
              !onCreateClassPath;
            const isCreateOnlineClassActive =
              item.page === "create-online-class" && onCreateClassPath;
            return (
              <NavLink
                key={item.path}
                to={item.path}
                end={
                  item.page === "online-classes" ||
                  item.page === "create-online-class"
                }
                className={({ isActive: linkActive }) =>
                  `admin-sidebar__link ${
                    linkActive ||
                    location.pathname === item.path ||
                    isOnlineClassesActive ||
                    isCreateOnlineClassActive
                      ? "is-active"
                      : ""
                  }`
                }
              >
                <Icon fontSize="small" />
                <span>{item.label}</span>
              </NavLink>
            );
          })}
        </nav>
      </div>

      <button type="button" className="admin-sidebar__logout" onClick={handleLogout}>
        <LogoutIcon fontSize="small" />
        <span>Logout</span>
      </button>
    </aside>
  );
}
